import { useState } from "react";
import {
  State,
  VectorTile as VectorTileSource,
} from "../../../../reactOL/source";
import MVT from "ol/format/MVT.js";
import {
  PtBoundariesStyles,
  PtBoundariesStylesDarkMode,
} from "../../../../boundarySelection/PtBoundariesStyles";
import { useThemeContext } from "../../../../theme/ThemeContext";
import VectorTile from "../../../../reactOL/layers/VectorTile";
import { Theme } from "../../../../../constant/Theme";
import { useViewContext } from "../../../../../context/View/ViewContext";

interface PublicTransportVectorTileLayerProps {
  visible: boolean;
}

const PublicTransportVectorTileLayer = ({
  visible,
}: PublicTransportVectorTileLayerProps) => {
  const { theme } = useThemeContext();
  const { projection, tileGrid, setLoading } = useViewContext();

  const [ptVectorTileSource] = useState(
    VectorTileSource({
      url: `${process.env.REACT_APP_DATAVIEWER_URL}PublicTransportTiles/{z}/{x}/{y}.mvt`,
      onStateChange: (state: State) => setLoading(state === State.Loading),
      authorizationToken: ``,
      projection: projection,
      format: new MVT(),
      tileGrid: tileGrid,
    }),
  );

  return (
    <VectorTile
      source={ptVectorTileSource}
      style={
        theme === Theme.DARK ? PtBoundariesStylesDarkMode : PtBoundariesStyles
      }
      zIndex={10000}
      visible={visible}
    />
  );
};

export default PublicTransportVectorTileLayer;
